import React from 'react';
import { Box, Typography, Stack, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';

const SelectorModule = ({ 
  title, 
  subtitle, 
  options, 
  value, 
  onChange, 
  multiple = false,
  premium = false,
  disabled = false
}) => {
  const isSelected = (id) => multiple ? value.includes(id) : value === id;

  const handleSelect = (id) => {
    if (multiple) {
      const current = [...value];
      const index = current.indexOf(id);
      if (index > -1) {
        current.splice(index, 1);
      } else {
        current.push(id);
      }
      onChange(current);
    } else {
      onChange(id);
    }
  };

  return (
    <Box sx={{ 
      p: premium ? 4 : 3, 
      borderRadius: premium ? '24px' : '12px', 
      bgcolor: 'white', 
      border: 1, borderColor: 'sutil' 
    }}>
      <Typography variant={premium ? "h6" : "subtitle1"} fontWeight="900" color="primary.main" sx={{ mb: 1 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: premium ? 4 : 2, fontWeight: 500 }}>
          {subtitle}
        </Typography>
      )}
      
      <Stack direction="row" spacing={premium ? 3 : 2} sx={{ flexWrap: 'wrap', gap: premium ? 0 : 2 }}>
        {options.map((opt) => {
          const active = isSelected(opt.id);
          return (
            <Paper
              key={opt.id}
              elevation={0}
              onClick={() => !disabled && handleSelect(opt.id)}
              sx={{ 
                flex: 1,
                minWidth: premium ? 'unset' : '150px',
                p: 2, 
                borderRadius: premium ? '12px' : '8px', 
                border: '1px solid',
                borderColor: active ? (disabled ? 'secondary.light' : 'secondary.main') : 'divider',
                cursor: disabled ? 'default' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                bgcolor: active && premium ? ((t) => alpha(t.palette.secondary.main, 0.04)) : 'white',
                opacity: disabled && !active ? 0.6 : 1,
                transition: 'all 0.2s ease-in-out',
                '&:hover': { 
                  borderColor: disabled ? (active ? 'secondary.light' : 'divider') : 'secondary.main',
                  bgcolor: disabled ? (active ? ((t) => alpha(t.palette.secondary.main, 0.02)) : 'white') : 'grey.50'
                }
              }}
            >
              <Box sx={{ 
                width: 40, 
                height: 40, 
                borderRadius: premium ? '10px' : '8px', 
                bgcolor: (t) => alpha(t.palette.secondary.main, 0.1), 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'primary.main'
              }}>
                {typeof opt.icon === 'string' && opt.icon.includes('/') ? (
                  <img 
                    src={opt.icon} 
                    alt={opt.title} 
                    style={{ width: 22, height: 14, borderRadius: '2px' }} 
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                ) : (
                  opt.icon
                )}
              </Box>
              <Box>
                <Typography variant="subtitle2" fontWeight="900" color="primary.main" sx={{ lineHeight: 1.2 }}>
                  {opt.title}
                </Typography>
                {opt.desc && (
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500, display: 'block', mt: 0.5 }}>
                    {opt.desc}
                  </Typography>
                )}
              </Box>
            </Paper>
          );
        })}
      </Stack>
    </Box>
  );
};

export default SelectorModule;
